import React, { useCallback } from 'react'

import { CommonDataContext } from 'shared-components/contexts/CommonDataContext'
import DealsCategoryTemplate from 'shared-components/templates/DealsCategoryTemplate'
import PlaywireTagged from 'shared-components/ad/PlaywireTagged'

import type { DSDealsCategoryPage } from 'shared-definitions/types'
import styleUtils from 'shared-components/styles/util.module.css'

import NC from 'nc/NC'
import { getds } from 'ds'
import type { DSNCAA } from 'types.aa.ds'

interface DealsCategoryTemplateAAProps {
  page: DSDealsCategoryPage<DSNCAA>
}

const DealsCategoryTemplateAA: React.VFC<DealsCategoryTemplateAAProps> = ({ page }) => {
  const { ts } = CommonDataContext.useContainer()
  const pageLoader = useCallback(
    async (pageNumber: number, perPage: number) => {
      const dataSource = await getds({ ts })
      const result = await dataSource.getTplPage(page.slug, pageNumber, perPage)
      if (
        !result.data ||
        result.data.resource === 'redirect' ||
        result.data.resource !== 'deals-category-page'
      ) {
        return null
      }

      return result.data
    },
    [page.slug, ts]
  )
  return (
    <DealsCategoryTemplate
      // Classless div: keeps the page wrapper out of ad-block rules that hide the ATF slot's parent (see TopicTemplateAA)
      leaderBoard={
        <div>
          <PlaywireTagged className={styleUtils.leaderboard} type="leaderboard_atf" />
        </div>
      }
      sideBar={<PlaywireTagged className={styleUtils.sidebarEl} type="med_rect_atf" />}
      page={page}
      nc={NC}
      pageLoader={pageLoader}
    />
  )
}

export default DealsCategoryTemplateAA
